// 환경별 설정
const environments = {
  development: {
    apiUrl: 'http://localhost:9595',
  },
  production: {
    // apiUrl은 도메인까지만 담는다 - 실제 호출부(useAuth.js/apiClient.js
    // 등)가 전부 apiUrl + '/api/...' 형태로 자기가 /api를 붙이므로,
    // 여기 /api를 포함하면 실제 요청이 /api/api/...로 이중이 돼서
    // 404가 난다(2026-08-29에 겪음 - pojjak.kr 전환 때 실수로 넣었었음).
    apiUrl: 'https://pojjak.kr',
  }
};

// 여기만 수정하면 됨 👇
const currentEnv = 'production'; // 'production'으로 바꿔서 push

export default environments[currentEnv];